import { ToastrService } from 'ngx-toastr';
import { ValidatorService } from './../../../core/service/app/validator.service';
import { Component, OnInit, Input } from '@angular/core';
import { FormBaseComponent } from '../../core/component/form-base/form-base.component';
import { FormControl, Validators } from '@angular/forms';
import { IMyDpOptions } from 'mydatepicker';
import { CatalogueService } from '../../../core/service/core/cataloque.service';
import { AppState } from 'app/store/app-state';
import { Store } from '@ngrx/store';
import swal from 'sweetalert2';
import { CommerceService } from 'app/core/service/app/commerce.service';
import { debug } from 'util';
import { Observable } from 'rxjs';


@Component({
  selector: 'app-person-moral-form',
  templateUrl: './person-moral-form.component.html',
  styleUrls: ['./person-moral-form.component.scss']
})
export class PersonMoralFormComponent extends FormBaseComponent<any>
  implements OnInit {
  private dateOptions: IMyDpOptions = {
    dateFormat: 'dd/mm/yyyy',
    showInputField: true
  };

  @Input() idTipoPersona: number = 0;
  @Input() commerceSat: { ciec : ""};

  satWs = { ciec : "A"};
  validacionSatWs: boolean;

  listaEstados = [];
  listaEstadosCivil = [];
  listaSubEstadosCivil = [];

  

  constructor(
    private commerceService: CommerceService,
    public validatorService: ValidatorService,
    private catalogueService: CatalogueService,
    private store: Store<AppState>,
    
  ) {
    
    super();
  }

  ngOnChanges()
  {
    if(this.commerceSat != undefined)
    {
      this.form.patchValue({ ciec: this.commerceSat.ciec });
    }
  }

  ngOnInit() {
    this.init(true);
    this.catalogueService.getStatesList('').then(result => {
      this.listaEstados = result;
    });

    this.catalogueService.getStatesCivilList('').then(result => {
      this.listaEstadosCivil = result;
    });

    this.catalogueService.getSubStatesCivil('1').then(result => {
      this.listaSubEstadosCivil = result;
    });
  }

  getSubEstadosCivil()
  {
    this.catalogueService.getSubStatesCivil(this.form.value.idEstadoCivil).then(result => {
      this.listaSubEstadosCivil = result;
    });
  }

  template() {
    this.form.addControl('socialRazon', new FormControl(null, Validators.required));
    this.form.addControl('dateConstitution', new FormControl(null, Validators.required));
    this.form.addControl('idEstadoCivil', new FormControl(0, Validators.required));
    this.form.addControl('idSubEstadoCivil', new FormControl(0));
    this.form.addControl('placeConstitution', new FormControl(null, Validators.required));
    this.form.addControl(
      'rfc',
      new FormControl('', [Validators.required])
    );
    this.form.addControl(
      'phone',
      new FormControl('', [this.validatorService.telefono])
    );
    this.form.addControl(
      'fax',
      new FormControl('', [this.validatorService.celular])
    );
    this.form.addControl('website', new FormControl(null));
    this.form.addControl('sameCommerce', new FormControl(null));
    this.form.addControl('sameFiscal', new FormControl(null));

    this.form.addControl('nombre', new FormControl(null));
    this.form.addControl('segNombre', new FormControl(null));
    this.form.addControl('apePaterno', new FormControl(null));
    this.form.addControl('apeMaterno', new FormControl(null));

    this.form.addControl('ciec', new FormControl(null));
  }

  validarSat(){
    this.commerceSat .ciec = this.form.value.ciec;
    if(this.commerceSat.ciec != ""){
      swal({
        title: 'Confirmación de Terminos',
        text: 'Acepto los términos y condiciones de Anticipa para el uso de la CIEC y como firma de autorización en medios electrónicos',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Si',
        cancelButtonText: 'No'
      }).then((result) => {
        if (result.value){
          
          this.commerceService.validateSatWs(this.commerceSat).then(result =>{
            
            swal({ title: "Proceso completo", text: "Los procesos de validación se iniciaran, puede llevar un tiempo. Puedes continuar con tu registro sin problema", type: "warning" });
            this.checkSatWs();
            
          });
        }
      });
    }
    else{
      swal({ title: "Información Incompleta", text: "Favor de indicar la contraseña CIEC", type: "warning" });
    }
  }

  checkSatWs()
  {
    var enc = true;
    Observable.interval(20000)
    .subscribe((val) => 
    {
      if(enc== true)
      {
        this.commerceService.checkSatWs(this.commerceSat).then(result =>{
          switch(result.object.message)
          {
            case "valid":
              enc = false;
              break;
            case "pending":
              break;
            default:
              enc = false;
              swal({ title: "Información Incorrecta", text: "La contraseña CIEC o RFC son Incorrectos favor de validar", type: "warning" });
              break;
          }
        });
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/form/form/person-moral-form/person-moral-form.component.ts